/**
 * Wallet Pass Service
 * Issues and serves Apple Wallet and Google Wallet loyalty passes for Convercus programs. Internal administrators register programs, mint program API keys, maintain store locations, configure wallet design and levels, read adoption analytics and query the audit trail; customer-facing clients download a pass through the program-scoped download routes, and the wallets themselves keep it current through the Apple PassKit web service and the Google Wallet Objects callback. Every path below already carries the gateway base prefix `/wallet-pass-service`.
 *
 * The version of the OpenAPI document: 1.0.39938
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ApiKeyListItemDto { 
    id: string;
    programId?: object | null;
    name: string;
    type: ApiKeyListItemDto.TypeEnum;
    createdAt?: string;
    /**
     * Masked key prefix for list views. The secret is never included.
     */
    displayValue: string;
}
export namespace ApiKeyListItemDto {
    export type TypeEnum = 0 | 1 | 2;
    export const TypeEnum = {
        NUMBER_0: 0 as TypeEnum,
        NUMBER_1: 1 as TypeEnum,
        NUMBER_2: 2 as TypeEnum
    };
}


